import { useEffect, useRef, useState } from "react";
import { ConvertToFloat, isValidArray } from "../../../../Layout/Common/common";
import { OrderItemRow } from "./orderItemRow";
import { OrderCartItemSkeleton } from "../../../../Skeleton/orderViewSkeleton";
import { useAuth } from "../../../../Context/AuthContext";
import { useGlobalFunction } from "../../../../Context/GlobalFunctionContext";
import { LoadMoreCartItem } from "../../../../Layout/Common/cartItemDynamicLoad";

export const OrderItemList = ({ items, orderId }) => {
  const [orderItem, setOrderItem] = useState();
  const [cartItem, setCartItem] = useState([]);
  const [totalCartItem, setTotalCartItem] = useState(0);
  useEffect(() => {
    if (items) {
      setOrderItem(items);
      setTotalCartItem(items.totalItem);
      setCartItem(items.cartItem);
    }
  }, [items]);

  return (
    <div className="col-lg-12 mt-3 mt-md-4 billingShipping-wrapper">
      {/* Order Items */}
      <div className="order-address">
        <div className="card order-address-card">
          <div className="card-header">
            <h5>
              <span className="wes wes-download" />
              Order Details
            </h5>
          </div>
          {cartItem && isValidArray(cartItem) ? (
            <div className="card-body order-address-body">
              <div className="row">
                {cartItem.map((row, index) => (
                  <OrderItemRow row={row} index={index} />
                ))}
              </div>
            </div>
          ) : (
            <OrderCartItemSkeleton />
          )}
        </div>
        <LoadMoreCartItem
          orderId={orderId}
          cartItem={cartItem}
          totalItem={totalCartItem}
          onItemsLoaded={(newItems) => setCartItem((prev) => [...prev, ...newItems])}
        />
        {orderItem && isValidArray(cartItem) && (
          <div className="order-summary-details">
            <div className="order-prices">
              <div className="order-prices-list">
                <p>Sub Total</p>
                <span>$ {orderItem && ConvertToFloat(orderItem.totalcost)}</span>
              </div>
              <div className="order-prices-list">
                <p> Shipping</p>
                <span>$ {orderItem && ConvertToFloat(orderItem.shipcost)}</span>
              </div>
              <div className="order-prices-list">
                <p>Tax Amount</p>
                <span>$ {orderItem && ConvertToFloat(orderItem.totaltax)}</span>
              </div>
              <div className="order-prices-list" style={{ display: "none" }}>
                <p>Freight</p>
                <span>TBA</span>
              </div>
            </div>
            <div className="order-prices-list order-prices-total" style={{ fontWeight: "bold" }}>
              <p>Total</p>
              <span>$ {orderItem && ConvertToFloat(orderItem.totalIncTax)}</span>
            </div>
          </div>
        )}
      </div>
      {/* Order Items */}
    </div>
  );
};
